import { OrganizationCall } from '@/common/api.service'
import { FETCH_ORGANIZATION } from './actions.type'
import { SET_ORGANIZATION } from './mutations.type'

const initialState = {
  organization: {
    id: '',
    name: '',
    description: '',
    services: [],
  },
}

export const state = {
  ...initialState,
}

export const actions = {
  /**
   * Get a single organization by id
   * @param {*} context
   * @param {*} payload
   */
  async [FETCH_ORGANIZATION](context, payload) {
    //console.log('[Fetching organization]: ' + payload)
    const { data } = await OrganizationCall.get(payload)
    context.commit(SET_ORGANIZATION, data)
    return data
  },
}

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  // Set collection
  [SET_ORGANIZATION](state, organization) {
    return (state.organization = organization)
  },
}

const getters = {
  organization(state) {
    return state.organization
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
